import React, { useState, useEffect } from "react";
import HamburguerBtn from "../../HamburguerBtn/HamburguerBtn";
import style from "./DesktopSideBar.module.css";
import logoIfh from "../../../assets/images/ifh-logo.png";
import { Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const DesktopSideBar = ({ sidebarExpanded, setSidebarExpanded, children }) => {
  const [role, setRole] = useState("");
  const userRole = sessionStorage.getItem("userRole");
  
  useEffect(()=>{
    if(userRole === "1"){
      setRole("Admin");
    }else if(userRole === "2"){
      setRole("Alumno");
    }else if(userRole === "3"){
      setRole("Profesor");
    }else{
      setRole("");
    }
  }, [userRole]);

  const handleOffcanvas = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  return (
    <div className={`${style.sidebar} ${sidebarExpanded && style.expanded}`}>
      <div
        className={`${style.sidebarTop} ${sidebarExpanded && style.sidebarTopExpanded}`}
      >
        <HamburguerBtn clicked={sidebarExpanded} handleOffcanvas={handleOffcanvas} />
      </div>
      <div className={style.logoContainer}>
        <NavLink to={`${userRole === '1' ? '/homeAdmin' : '/homeAlumno'}`}>
          <Image src={logoIfh} className={style.logo} />
        </NavLink>
      </div>
      <div>{sidebarExpanded && role && <p className={`m-0 ${style.linkTxt} ${style.profileLink}`}>Perfil: {role}</p>} </div>
        {/* Botones de la sidebar */}
        {children}
    </div>
  );
};

export default DesktopSideBar;